import { __decorate } from "tslib";
import HelixElement from '../../shared/types/helix-element.js';
import { customElement, property, state } from 'lit/decorators.js';
import { html } from 'lit';
import { consume } from '@lit/context';
import { activeTabNameContext } from './tab-group-context.js';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { tabStyles } from './tab-group.styles.js';
import { classMap } from 'lit/directives/class-map.js';
import { createRef, ref } from 'lit-html/directives/ref.js';
import { watch } from '../../shared/directives/watch.decorator.js';
let HlxTab = class HlxTab extends HelixElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.role = 'tab';
        this.ariaSelected = 'false';
        this.hasFocus = false;
        this.buttonRef = createRef();
        this.emitTabClickEvent = () => {
            if (!this.disabled) {
                this.emit('hlx-tab-click', { name: this.name }, { bubbles: true });
                this.focus();
            }
        };
    }
    markSelected() {
        const isSelected = this.name === this.activeTabName;
        this.ariaSelected = isSelected ? 'true' : 'false';
    }
    render() {
        const isSelected = this.name === this.activeTabName;
        return html `
            <button
                @keydown=${this.handleKeyDown}
                tabindex=${isSelected ? 0 : -1}
                ?disabled=${this.disabled}
                class=${classMap({
            'hlx-tab-header': true,
            'hlx-animation-with-prefers-reduced-motion': true,
            'hlx-tab-header-selected': isSelected,
        })}
                @focus=${this.handleFocus}
                @pointerdown=${(event) => {
            // Preventing default so that the element is focused only after click.
            // Otherwise, focus happened before the click event,
            // and if as a result the tab container is scrolled,
            // click never actually happens.
            event.preventDefault();
        }}
                ${ref(this.buttonRef)}>
                <slot></slot>
            </button>
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.emitTabClickEvent);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.emitTabClickEvent);
    }
    handleFocus() {
        this.emit('hlx-tab-focus', { direction: 'none' }, { bubbles: true });
    }
    handleKeyDown(event) {
        let direction;
        if (event.code === 'ArrowRight' || event.code === 'ArrowDown') {
            direction = 'next';
        }
        if (event.code === 'ArrowLeft' || event.code === 'ArrowUp') {
            direction = 'prev';
        }
        if (direction) {
            event.preventDefault();
            this.emit('hlx-tab-focus', { direction }, { bubbles: true });
        }
    }
};
HlxTab.shadowRootOptions = { ...HelixElement.shadowRootOptions, delegatesFocus: true };
HlxTab.styles = [componentStyles, tabStyles];
__decorate([
    property({ reflect: true })
], HlxTab.prototype, "name", void 0);
__decorate([
    property({ type: Boolean })
], HlxTab.prototype, "disabled", void 0);
__decorate([
    consume({ context: activeTabNameContext, subscribe: true }),
    property({ type: String, attribute: false })
], HlxTab.prototype, "activeTabName", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxTab.prototype, "role", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'aria-selected' })
], HlxTab.prototype, "ariaSelected", void 0);
__decorate([
    state()
], HlxTab.prototype, "hasFocus", void 0);
__decorate([
    watch('activeTabName')
], HlxTab.prototype, "markSelected", null);
HlxTab = __decorate([
    customElement('hlx-tab')
], HlxTab);
export { HlxTab };
//# sourceMappingURL=tab.js.map